import UIComponent from './UIComponent';
import Element from '../../Prototype/UI/Element';
import * as PIXI from 'pixi.js';
import '@sgorg/pixi-ui';
import PIXIRenderer from '../../System/Render/PIXIRenderer';
import Point from '../../Utility/Point';
import ObservablePoint from '../../Utility/ObservablePoint';

export default class UIImageComponent extends UIComponent {
    public UIComponent: PIXI.ui.component.Image;
    private _texture: string;

    public attach(gameObject: Element, params: any): void {
        this.UIComponent = new PIXI.ui.component.Image(
            PIXIRenderer.getTexture(params.data.cacheKey)
        );

        gameObject.container.add(this.UIComponent);

        super.attach(gameObject, params);
    }

    get texture(): string {
        return this._texture;
    }

    set texture(value: string) {
        this._texture = value;

        this.UIComponent.imageSprite.texture = PIXIRenderer.getTexture(value);
    }

    get anchor(): Point | ObservablePoint {
        return this.UIComponent.imageSprite.anchor as Point | ObservablePoint;
    }

    set anchor(value: Point | ObservablePoint) {
        this.UIComponent.imageSprite.anchor.set(value.x, value.y);
    }

    get width(): number {
        return this.UIComponent.imageSprite.width;
    }

    set width(value: number) {
        this.UIComponent.imageSprite.width = value;
    }

    get height(): number {
        return this.UIComponent.imageSprite.height;
    }

    set height(value: number) {
        this.UIComponent.imageSprite.height = value;
    }

    get tint(): number {
        return this.UIComponent.imageSprite.tint;
    }

    set tint(value: number) {
        this.UIComponent.imageSprite.tint = value;
    }

    set mipmap(value: boolean) {
        this.UIComponent.imageSprite.texture.baseTexture.mipmap = value;
    }
    get mipmap(): boolean {
        return this.UIComponent.imageSprite.texture.baseTexture.mipmap;
    }
}
